import {
  Archive,
  CircleHelp,
} from 'lucide-react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { AppShell } from './components/AppShell';
import { DashboardPage } from './pages/DashboardPage';
import { ElaborationsPage } from './pages/ElaborationsPage';
import { LandingPage } from './pages/LandingPage';
import { LoginPage } from './pages/LoginPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { OutputPage } from './pages/OutputPage';
import { PlaceholderPage } from './pages/PlaceholderPage';
import { SourcesPage } from './pages/SourcesPage';
import { SettingsPage } from './pages/SettingsPage';
import { ValidationPage } from './pages/ValidationPage';

function PrivateApp() {
  return (
    <ProtectedRoute>
      <AppShell>
        <Routes>
          <Route index element={<DashboardPage />} />
          <Route path="sorgenti" element={<SourcesPage />} />
          <Route path="elaborazioni" element={<ElaborationsPage />} />
          <Route path="validazione" element={<ValidationPage />} />
          <Route path="output" element={<OutputPage />} />
          <Route path="aree-territoriali" element={<Navigate to="/app/impostazioni?tab=aree-territoriali" replace />} />
          <Route path="gestione-code-province" element={<Navigate to="/app/impostazioni?tab=gestione-code-province" replace />} />
          <Route path="regole-territoriali" element={<Navigate to="/app/impostazioni?tab=gestione-code-province" replace />} />
          <Route path="template" element={<PlaceholderPage title="Template report" eyebrow="Configurazione" description="Gestisci strutture, tabelle, grafici e template PowerPoint di riferimento." icon={Archive} />} />
          <Route path="utenti" element={<Navigate to="/app/impostazioni?tab=utenti-accessi" replace />} />
          <Route path="impostazioni" element={<SettingsPage />} />
          <Route path="guida" element={<PlaceholderPage title="Guida e supporto" eyebrow="Risorse" description="Trova indicazioni operative e riferimenti per ricevere assistenza." icon={CircleHelp} />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </AppShell>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/accesso" element={<LoginPage />} />
      <Route path="/app/*" element={<PrivateApp />} />
      <Route path="*" element={<Navigate to="/app" replace />} />
    </Routes>
  );
}
